import { RowSelectionState } from '@tanstack/react-table'
import { useMemo, useState } from 'react'

export function useRowSelection<T extends { id: number | string }>(data: T[]) {
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({})

  const selectedIds = useMemo(() => {
    return data.filter((_, index) => rowSelection[index]).map(row => row.id)
  }, [data, rowSelection])

  const selectedRows = useMemo(() => {
    return data.filter(_ => rowSelection[_.id])
  }, [data, rowSelection])

  function removeRow(index: number) {
    const newRowSelection = { ...rowSelection, [index]: false }

    setRowSelection(newRowSelection)
  }

  return {
    rowSelection,
    setRowSelection,
    selectedIds,
    selectedRows,
    removeRow
  }
}
